export const message = {
  saveDraftCustomFilterMessage: 'Report Filters successfully saved',
  publishCustomFilterMessage: 'Report Filters successfully published',
};